import { useEffect } from 'react';
import useUrlChange from './useUrlChange';

const useAccessibilityPageTitle = (mainTitle = '', titleMap = {}, lang = 'en') => {
    
    const url = useUrlChange();

    useEffect(() => {
        const path = new URL(url).pathname;
        const currentTitle = path
            .split('/')
            .filter(key => titleMap[key]?.[lang])
            .map(key => titleMap[key][lang]);

        let title = mainTitle;
        if (currentTitle.length) {
            title = `${title} | ${currentTitle.join(' ')}`;
        }
        document.title = title;

        return () => {
            // Reset the page title when the component unmounts
            document.title = '';
        };
    }, [url, mainTitle, titleMap, lang]);
};

export default useAccessibilityPageTitle;
